import { render, staticRenderFns } from "./AffiliationsCombo.vue?vue&type=template&id=64986ede&scoped=true"
import script from "./AffiliationsCombo.vue?vue&type=script&lang=js"
export * from "./AffiliationsCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64986ede",
  null
  
)

export default component.exports